import FooterBottomTopHook from '~/themes/base/components/shop/FooterBottomTopHook'

export default {
  extends: FooterBottomTopHook,
}
